// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StepMappingEditor.module.css
   Styles owned exclusively by the param-first mapping editor. */

.StepMappingEditor_mappingSection__idajm {
  padding: 8px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.StepMappingEditor_mappingHint__8k7sD {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 4px;
  line-height: 1.5;
}

.StepMappingEditor_fieldsRow__OCIJE {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.StepMappingEditor_availableFieldsBox__FL-Kq {
  flex: 1 1 260px;
  background: #f5f8ff;
  border: 1px solid #d0d9f0;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  color: #1e3a8a;
}

.StepMappingEditor_availableFieldsBox__FL-Kq strong {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #4a5568;
  margin-bottom: 6px;
}

.StepMappingEditor_fieldChips__dJws3 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.StepMappingEditor_fieldChip__fsbtD {
  background: #e0e7ff;
  color: #1e3a8a;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  white-space: nowrap;
}

.StepMappingEditor_tabs__htNZ8 {
  display: flex;
  gap: 4px;
  margin: 4px 0 6px;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.StepMappingEditor_tab__pruFg {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  color: #4a5568;
  font-weight: 500;
  font-size: 12.5px;
  transition: all 0.15s;
  margin-bottom: -1px;
  white-space: nowrap;
}

.StepMappingEditor_tab__pruFg:hover { color: #2d3748; }
.StepMappingEditor_tabActive__Kp4OR { color: #4a90d9; border-bottom-color: #4a90d9; }
.StepMappingEditor_tabDisabled__RZe08 { opacity: 0.45; cursor: not-allowed; color: #a0aec0; }

.StepMappingEditor_tabBadge__Ylivu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;
  padding: 0 5px;
  margin-left: 4px;
  background: #edf2f7;
  border-radius: 8px;
  font-size: 10.5px;
  color: #4a5568;
  font-weight: 600;
}

.StepMappingEditor_tabActive__Kp4OR .StepMappingEditor_tabBadge__Ylivu { background: #bee3f8; color: #2b6cb0; }

/* =============================================================
   Header strip — labels the two sides of every row below.
   ============================================================= */
.StepMappingEditor_mappingHeader__dSE2\\+ {
  display: grid;
  grid-template-columns:
    minmax(220px, 1.9fr)
    24px
    minmax(140px, 1.2fr)
    minmax(120px, 1fr)
    minmax(90px, 0.7fr)
    minmax(80px, 0.6fr);
  align-items: center;
  column-gap: 10px;
  padding: 6px 10px;
  margin: 4px 0 6px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #718096;
}

.StepMappingEditor_mappingHeaderSide__rVfao {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.StepMappingEditor_mappingHeader__dSE2\\+ > .StepMappingEditor_mappingHeaderSide__rVfao:nth-of-type(1) {
  grid-column: 1 / 2;
}

.StepMappingEditor_mappingHeaderArrow__M5crc {
  grid-column: 2 / 3;
  display: flex;
  justify-content: center;
  color: #cbd5e0;
}

.StepMappingEditor_mappingHeader__dSE2\\+ > .StepMappingEditor_mappingHeaderSide__rVfao:nth-of-type(2) {
  grid-column: 3 / 7;
}

.StepMappingEditor_mappingHeaderTag__j0VIh {
  font-weight: 700;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 4px;
  background: #edf2f7;
  color: #4a5568;
  flex: 0 0 auto;
}

.StepMappingEditor_mappingHeaderLabel__BCaJ4 {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 11px;
  color: #2d3748;
  text-transform: none;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1 1;
}

.StepMappingEditor_mappingRows__I5zS7 { display: flex; flex-direction: column; gap: 6px; }

.StepMappingEditor_mappingRow__h6UAR {
  display: block;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e8ecf3;
  border-radius: 8px;
  transition: background 0.15s;
}

.StepMappingEditor_mappingRow__h6UAR:hover { background: #fafbfc; }

/* =============================================================
   Row layout — SOURCE on the left, DESTINATION on the right.
   ============================================================= */
.StepMappingEditor_mappingRowMain__6b5Ow {
  display: grid;
  grid-template-columns:
    minmax(220px, 1.9fr)
    24px
    minmax(140px, 1.2fr)
    minmax(120px, 1fr)
    minmax(90px, 0.7fr)
    minmax(80px, 0.6fr);
  align-items: center;
  column-gap: 10px;
}

.StepMappingEditor_mappingColumn__\\+7Yfz {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 12.5px;
  color: #2d3748;
}

.StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(1) > * {
  width: 100%;
  min-width: 0;
}

.StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(2) {
  justify-content: center;
  color: #cbd5e0;
}

.StepMappingEditor_mappingArrow__AasL2 { font-size: 12px; }

.StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(3) {
  min-width: 0;
}

.StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(4) > * {
  width: 100%;
  min-width: 0;
}

.StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(5) { justify-content: center; }

.StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(6) {
  justify-content: flex-end;
  gap: 4px;
}

.StepMappingEditor_paramHeader__XqnVF {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  min-width: 0;
}

.StepMappingEditor_fieldName__g-X6Z {
  font-weight: 600;
  color: #2d3748;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12.5px;
  word-break: break-word;
}

.StepMappingEditor_fieldType__TDRd5 {
  font-size: 10.5px;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.StepMappingEditor_typeBadge__AyUUk {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 8px;
  white-space: nowrap;
  color: white;
  letter-spacing: 0.02em;
}

.StepMappingEditor_selectWrapperSmall__97O1b { position: relative; width: 100%; min-width: 0; }

.StepMappingEditor_selectIconSmall__irfFo {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  pointer-events: none;
  font-size: 10px;
}

.StepMappingEditor_mappingSelect__XQVkG,
.StepMappingEditor_conversionSelect__\\+JbJ6 {
  width: 100%;
  min-width: 0;
  padding: 5px 24px 5px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  font-family: inherit;
  background: #fff;
  color: #2d3748;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.StepMappingEditor_mappingSelect__XQVkG:focus,
.StepMappingEditor_conversionSelect__\\+JbJ6:focus {
  outline: none;
  border-color: #4a90d9;
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.15);
}

.StepMappingEditor_locationBadge__GThQ2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10.5px;
  padding: 3px 8px;
  border-radius: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.StepMappingEditor_locationBadge__GThQ2.StepMappingEditor_path__NstvP { background: #fef3c7; color: #92400e; }
.StepMappingEditor_locationBadge__GThQ2.StepMappingEditor_query__U5COi { background: #dbeafe; color: #1e40af; }
.StepMappingEditor_locationBadge__GThQ2.StepMappingEditor_payload__d47yj { background: #d1fae5; color: #065f46; }

.StepMappingEditor_templateToggleBtn__WfQzS {
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #4a5568;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  line-height: 1;
}

.StepMappingEditor_templateToggleBtn__WfQzS:hover { background: #edf2f7; border-color: #cbd5e0; }

.StepMappingEditor_templateToggleBtnActive__YThXU {
  border-color: #9f7aea;
  background: #faf5ff;
  color: #6b46c1;
}

.StepMappingEditor_templateToggleBtnActive__YThXU:hover { background: #f3e8ff; }

.StepMappingEditor_removeButton__v3k1s {
  background: none;
  border: none;
  color: #e53e3e;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  transition: background 0.15s;
}

.StepMappingEditor_removeButton__v3k1s:hover { background: #fff5f5; }

.StepMappingEditor_autoMapBtn__6waA- {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  background: #e9d8fd;
  color: #553c9a;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11.5px;
  transition: background 0.15s;
}

.StepMappingEditor_autoMapBtn__6waA-:hover { background: #d6bcfa; }

.StepMappingEditor_templateEditor__eIRlJ {
  margin-top: 10px;
  padding: 10px 12px;
  background: #fafafa;
  border: 1px solid #e9e3f5;
  border-radius: 6px;
}

.StepMappingEditor_templateEditorHint__w4BVq {
  font-size: 11.5px;
  color: #4a5568;
  margin-bottom: 8px;
  line-height: 1.5;
}

.StepMappingEditor_templateTextarea__1rErA {
  width: 100%;
  box-sizing: border-box;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12px;
  padding: 8px 10px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  background: #fff;
  resize: vertical;
  line-height: 1.5;
  color: #2d3748;
}

.StepMappingEditor_templateTextarea__1rErA:focus {
  outline: none;
  border-color: #9f7aea;
  box-shadow: 0 0 0 3px rgba(159, 122, 234, 0.15);
}

.StepMappingEditor_templateFieldChips__jSHy1 {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.StepMappingEditor_templateFieldChipsLabel__V0nHl {
  font-size: 10.5px;
  color: #718096;
  margin-right: 4px;
  font-weight: 500;
}

.StepMappingEditor_templateFieldChip__RxrSV {
  padding: 2px 8px;
  font-size: 10.5px;
  border-radius: 10px;
  border: 1px solid #cbd5e0;
  background: #fff;
  color: #4a5568;
  cursor: pointer;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  transition: all 0.15s;
  line-height: 1.4;
}

.StepMappingEditor_templateFieldChip__RxrSV:hover {
  background: #faf5ff;
  border-color: #9f7aea;
  color: #6b46c1;
}

.StepMappingEditor_templatePreview__wgFqa { margin-top: 8px; padding: 6px 10px; border-radius: 4px; font-size: 11px; }
.StepMappingEditor_templatePreviewJson__Ve68O { background: #f0fff4; border: 1px solid #9ae6b4; }
.StepMappingEditor_templatePreviewString__2rEBA { background: #ebf8ff; border: 1px solid #90cdf4; }
.StepMappingEditor_templatePreviewEmpty__V6OGC { background: #fffaf0; border: 1px solid #f6ad55; }

.StepMappingEditor_templatePreviewLabel__orjz1 { font-weight: 600; margin-bottom: 2px; font-size: 11px; }
.StepMappingEditor_templatePreviewJson__Ve68O .StepMappingEditor_templatePreviewLabel__orjz1 { color: #22543d; }
.StepMappingEditor_templatePreviewString__2rEBA .StepMappingEditor_templatePreviewLabel__orjz1 { color: #2a4365; }
.StepMappingEditor_templatePreviewEmpty__V6OGC .StepMappingEditor_templatePreviewLabel__orjz1 { color: #744210; }

.StepMappingEditor_templatePreviewValue__ob2mU {
  font-size: 11.5px;
  word-break: break-all;
  white-space: pre-wrap;
  color: #2d3748;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  display: block;
  line-height: 1.5;
}

@media (max-width: 1023px) {
  .StepMappingEditor_mappingRowMain__6b5Ow,
  .StepMappingEditor_mappingHeader__dSE2\\+ {
    grid-template-columns:
      minmax(160px, 1.6fr)
      24px
      minmax(120px, 1.2fr)
      minmax(80px, 0.7fr);
  }

  .StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(4),
  .StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(5) {
    display: none;
  }

  .StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(6) {
    grid-column: 4 / 5;
  }

  .StepMappingEditor_mappingHeader__dSE2\\+ > .StepMappingEditor_mappingHeaderSide__rVfao:nth-of-type(2) {
    grid-column: 3 / 5;
  }
}

@media (max-width: 639px) {
  .StepMappingEditor_mappingRowMain__6b5Ow,
  .StepMappingEditor_mappingHeader__dSE2\\+ {
    grid-template-columns: 1fr;
    row-gap: 6px;
  }

  .StepMappingEditor_mappingRowMain__6b5Ow .StepMappingEditor_mappingColumn__\\+7Yfz:nth-child(2) {
    display: none;
  }

  .StepMappingEditor_mappingHeaderArrow__M5crc { display: none; }

  .StepMappingEditor_mappingHeader__dSE2\\+ > .StepMappingEditor_mappingHeaderSide__rVfao:nth-of-type(1),
  .StepMappingEditor_mappingHeader__dSE2\\+ > .StepMappingEditor_mappingHeaderSide__rVfao:nth-of-type(2) {
    grid-column: 1 / -1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/StepMappingEditor.module.css"],"names":[],"mappings":"AAAA;gEACgE;;AAEhE;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sCAAa,cAAc,EAAE;AAC7B,sCAAa,cAAc,EAAE,4BAA4B,EAAE;AAC3D,wCAAe,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAEnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yEAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D;;kEAEkE;AAClE;EACE,aAAa;EACb;;;;;;uBAMqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,SAAO;AACT;;AAEA,wCAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEhE;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,6CAAoB,mBAAmB,EAAE;;AAEzC;;kEAEkE;AAClE;EACE,aAAa;EACb;;;;;;uBAMqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,yCAAgB,eAAe,EAAE;;AAEjC;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iGAA8C,uBAAuB,EAAE;;AAEvE;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,+CAAsB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE;;AAErE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wEAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,yEAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,2EAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oDAA2B,mBAAmB,EAAE,qBAAqB,EAAE;;AAEvE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0DAAiC,mBAAmB,EAAE;;AAEtD;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,+CAAsB,mBAAmB,EAAE;;AAE3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,6CAAoB,mBAAmB,EAAE;;AAEzC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kDAAkD;EAClD,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4CAAmB,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC5F,gDAAuB,mBAAmB,EAAE,yBAAyB,EAAE;AACvE,kDAAyB,mBAAmB,EAAE,yBAAyB,EAAE;AACzE,iDAAwB,mBAAmB,EAAE,yBAAyB,EAAE;;AAExE,iDAAwB,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC/E,+FAA6C,cAAc,EAAE;AAC7D,iGAA+C,cAAc,EAAE;AAC/D,gGAA8C,cAAc,EAAE;;AAE9D;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;;IAEE;;;;yBAIqB;EACvB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,+CAAsB,aAAa,EAAE;;EAErC;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":["/* StepMappingEditor.module.css\n   Styles owned exclusively by the param-first mapping editor. */\n\n.mappingSection {\n  padding: 8px 0 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mappingHint {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0 0 4px;\n  line-height: 1.5;\n}\n\n.fieldsRow {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.availableFieldsBox {\n  flex: 1 1 260px;\n  background: #f5f8ff;\n  border: 1px solid #d0d9f0;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 12px;\n  color: #1e3a8a;\n}\n\n.availableFieldsBox strong {\n  display: block;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #4a5568;\n  margin-bottom: 6px;\n}\n\n.fieldChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.fieldChip {\n  background: #e0e7ff;\n  color: #1e3a8a;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  white-space: nowrap;\n}\n\n.tabs {\n  display: flex;\n  gap: 4px;\n  margin: 4px 0 6px;\n  border-bottom: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  color: #4a5568;\n  font-weight: 500;\n  font-size: 12.5px;\n  transition: all 0.15s;\n  margin-bottom: -1px;\n  white-space: nowrap;\n}\n\n.tab:hover { color: #2d3748; }\n.tabActive { color: #4a90d9; border-bottom-color: #4a90d9; }\n.tabDisabled { opacity: 0.45; cursor: not-allowed; color: #a0aec0; }\n\n.tabBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 16px;\n  padding: 0 5px;\n  margin-left: 4px;\n  background: #edf2f7;\n  border-radius: 8px;\n  font-size: 10.5px;\n  color: #4a5568;\n  font-weight: 600;\n}\n\n.tabActive .tabBadge { background: #bee3f8; color: #2b6cb0; }\n\n/* =============================================================\n   Header strip — labels the two sides of every row below.\n   ============================================================= */\n.mappingHeader {\n  display: grid;\n  grid-template-columns:\n    minmax(220px, 1.9fr)\n    24px\n    minmax(140px, 1.2fr)\n    minmax(120px, 1fr)\n    minmax(90px, 0.7fr)\n    minmax(80px, 0.6fr);\n  align-items: center;\n  column-gap: 10px;\n  padding: 6px 10px;\n  margin: 4px 0 6px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 10.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #718096;\n}\n\n.mappingHeaderSide {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.mappingHeader > .mappingHeaderSide:nth-of-type(1) {\n  grid-column: 1 / 2;\n}\n\n.mappingHeaderArrow {\n  grid-column: 2 / 3;\n  display: flex;\n  justify-content: center;\n  color: #cbd5e0;\n}\n\n.mappingHeader > .mappingHeaderSide:nth-of-type(2) {\n  grid-column: 3 / 7;\n}\n\n.mappingHeaderTag {\n  font-weight: 700;\n  font-size: 10px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: #edf2f7;\n  color: #4a5568;\n  flex: 0 0 auto;\n}\n\n.mappingHeaderLabel {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 11px;\n  color: #2d3748;\n  text-transform: none;\n  letter-spacing: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex: 1;\n}\n\n.mappingRows { display: flex; flex-direction: column; gap: 6px; }\n\n.mappingRow {\n  display: block;\n  padding: 8px 10px;\n  background: #fff;\n  border: 1px solid #e8ecf3;\n  border-radius: 8px;\n  transition: background 0.15s;\n}\n\n.mappingRow:hover { background: #fafbfc; }\n\n/* =============================================================\n   Row layout — SOURCE on the left, DESTINATION on the right.\n   ============================================================= */\n.mappingRowMain {\n  display: grid;\n  grid-template-columns:\n    minmax(220px, 1.9fr)\n    24px\n    minmax(140px, 1.2fr)\n    minmax(120px, 1fr)\n    minmax(90px, 0.7fr)\n    minmax(80px, 0.6fr);\n  align-items: center;\n  column-gap: 10px;\n}\n\n.mappingColumn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  font-size: 12.5px;\n  color: #2d3748;\n}\n\n.mappingRowMain .mappingColumn:nth-child(1) > * {\n  width: 100%;\n  min-width: 0;\n}\n\n.mappingRowMain .mappingColumn:nth-child(2) {\n  justify-content: center;\n  color: #cbd5e0;\n}\n\n.mappingArrow { font-size: 12px; }\n\n.mappingRowMain .mappingColumn:nth-child(3) {\n  min-width: 0;\n}\n\n.mappingRowMain .mappingColumn:nth-child(4) > * {\n  width: 100%;\n  min-width: 0;\n}\n\n.mappingRowMain .mappingColumn:nth-child(5) { justify-content: center; }\n\n.mappingRowMain .mappingColumn:nth-child(6) {\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.paramHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.fieldName {\n  font-weight: 600;\n  color: #2d3748;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  word-break: break-word;\n}\n\n.fieldType {\n  font-size: 10.5px;\n  color: #718096;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.typeBadge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 6px;\n  border-radius: 8px;\n  white-space: nowrap;\n  color: white;\n  letter-spacing: 0.02em;\n}\n\n.selectWrapperSmall { position: relative; width: 100%; min-width: 0; }\n\n.selectIconSmall {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #a0aec0;\n  pointer-events: none;\n  font-size: 10px;\n}\n\n.mappingSelect,\n.conversionSelect {\n  width: 100%;\n  min-width: 0;\n  padding: 5px 24px 5px 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: inherit;\n  background: #fff;\n  color: #2d3748;\n  appearance: none;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.mappingSelect:focus,\n.conversionSelect:focus {\n  outline: none;\n  border-color: #4a90d9;\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.15);\n}\n\n.locationBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10.5px;\n  padding: 3px 8px;\n  border-radius: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.locationBadge.path { background: #fef3c7; color: #92400e; }\n.locationBadge.query { background: #dbeafe; color: #1e40af; }\n.locationBadge.payload { background: #d1fae5; color: #065f46; }\n\n.templateToggleBtn {\n  padding: 4px 8px;\n  font-size: 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #4a5568;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n  line-height: 1;\n}\n\n.templateToggleBtn:hover { background: #edf2f7; border-color: #cbd5e0; }\n\n.templateToggleBtnActive {\n  border-color: #9f7aea;\n  background: #faf5ff;\n  color: #6b46c1;\n}\n\n.templateToggleBtnActive:hover { background: #f3e8ff; }\n\n.removeButton {\n  background: none;\n  border: none;\n  color: #e53e3e;\n  cursor: pointer;\n  padding: 4px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 4px;\n  transition: background 0.15s;\n}\n\n.removeButton:hover { background: #fff5f5; }\n\n.autoMapBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  background: #e9d8fd;\n  color: #553c9a;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11.5px;\n  transition: background 0.15s;\n}\n\n.autoMapBtn:hover { background: #d6bcfa; }\n\n.templateEditor {\n  margin-top: 10px;\n  padding: 10px 12px;\n  background: #fafafa;\n  border: 1px solid #e9e3f5;\n  border-radius: 6px;\n}\n\n.templateEditorHint {\n  font-size: 11.5px;\n  color: #4a5568;\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n.templateTextarea {\n  width: 100%;\n  box-sizing: border-box;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  background: #fff;\n  resize: vertical;\n  line-height: 1.5;\n  color: #2d3748;\n}\n\n.templateTextarea:focus {\n  outline: none;\n  border-color: #9f7aea;\n  box-shadow: 0 0 0 3px rgba(159, 122, 234, 0.15);\n}\n\n.templateFieldChips {\n  margin-top: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n.templateFieldChipsLabel {\n  font-size: 10.5px;\n  color: #718096;\n  margin-right: 4px;\n  font-weight: 500;\n}\n\n.templateFieldChip {\n  padding: 2px 8px;\n  font-size: 10.5px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e0;\n  background: #fff;\n  color: #4a5568;\n  cursor: pointer;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  transition: all 0.15s;\n  line-height: 1.4;\n}\n\n.templateFieldChip:hover {\n  background: #faf5ff;\n  border-color: #9f7aea;\n  color: #6b46c1;\n}\n\n.templatePreview { margin-top: 8px; padding: 6px 10px; border-radius: 4px; font-size: 11px; }\n.templatePreviewJson { background: #f0fff4; border: 1px solid #9ae6b4; }\n.templatePreviewString { background: #ebf8ff; border: 1px solid #90cdf4; }\n.templatePreviewEmpty { background: #fffaf0; border: 1px solid #f6ad55; }\n\n.templatePreviewLabel { font-weight: 600; margin-bottom: 2px; font-size: 11px; }\n.templatePreviewJson .templatePreviewLabel { color: #22543d; }\n.templatePreviewString .templatePreviewLabel { color: #2a4365; }\n.templatePreviewEmpty .templatePreviewLabel { color: #744210; }\n\n.templatePreviewValue {\n  font-size: 11.5px;\n  word-break: break-all;\n  white-space: pre-wrap;\n  color: #2d3748;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  display: block;\n  line-height: 1.5;\n}\n\n@media (max-width: 1023px) {\n  .mappingRowMain,\n  .mappingHeader {\n    grid-template-columns:\n      minmax(160px, 1.6fr)\n      24px\n      minmax(120px, 1.2fr)\n      minmax(80px, 0.7fr);\n  }\n\n  .mappingRowMain .mappingColumn:nth-child(4),\n  .mappingRowMain .mappingColumn:nth-child(5) {\n    display: none;\n  }\n\n  .mappingRowMain .mappingColumn:nth-child(6) {\n    grid-column: 4 / 5;\n  }\n\n  .mappingHeader > .mappingHeaderSide:nth-of-type(2) {\n    grid-column: 3 / 5;\n  }\n}\n\n@media (max-width: 639px) {\n  .mappingRowMain,\n  .mappingHeader {\n    grid-template-columns: 1fr;\n    row-gap: 6px;\n  }\n\n  .mappingRowMain .mappingColumn:nth-child(2) {\n    display: none;\n  }\n\n  .mappingHeaderArrow { display: none; }\n\n  .mappingHeader > .mappingHeaderSide:nth-of-type(1),\n  .mappingHeader > .mappingHeaderSide:nth-of-type(2) {\n    grid-column: 1 / -1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mappingSection": `StepMappingEditor_mappingSection__idajm`,
	"mappingHint": `StepMappingEditor_mappingHint__8k7sD`,
	"fieldsRow": `StepMappingEditor_fieldsRow__OCIJE`,
	"availableFieldsBox": `StepMappingEditor_availableFieldsBox__FL-Kq`,
	"fieldChips": `StepMappingEditor_fieldChips__dJws3`,
	"fieldChip": `StepMappingEditor_fieldChip__fsbtD`,
	"tabs": `StepMappingEditor_tabs__htNZ8`,
	"tab": `StepMappingEditor_tab__pruFg`,
	"tabActive": `StepMappingEditor_tabActive__Kp4OR`,
	"tabDisabled": `StepMappingEditor_tabDisabled__RZe08`,
	"tabBadge": `StepMappingEditor_tabBadge__Ylivu`,
	"mappingHeader": `StepMappingEditor_mappingHeader__dSE2+`,
	"mappingHeaderSide": `StepMappingEditor_mappingHeaderSide__rVfao`,
	"mappingHeaderArrow": `StepMappingEditor_mappingHeaderArrow__M5crc`,
	"mappingHeaderTag": `StepMappingEditor_mappingHeaderTag__j0VIh`,
	"mappingHeaderLabel": `StepMappingEditor_mappingHeaderLabel__BCaJ4`,
	"mappingRows": `StepMappingEditor_mappingRows__I5zS7`,
	"mappingRow": `StepMappingEditor_mappingRow__h6UAR`,
	"mappingRowMain": `StepMappingEditor_mappingRowMain__6b5Ow`,
	"mappingColumn": `StepMappingEditor_mappingColumn__+7Yfz`,
	"mappingArrow": `StepMappingEditor_mappingArrow__AasL2`,
	"paramHeader": `StepMappingEditor_paramHeader__XqnVF`,
	"fieldName": `StepMappingEditor_fieldName__g-X6Z`,
	"fieldType": `StepMappingEditor_fieldType__TDRd5`,
	"typeBadge": `StepMappingEditor_typeBadge__AyUUk`,
	"selectWrapperSmall": `StepMappingEditor_selectWrapperSmall__97O1b`,
	"selectIconSmall": `StepMappingEditor_selectIconSmall__irfFo`,
	"mappingSelect": `StepMappingEditor_mappingSelect__XQVkG`,
	"conversionSelect": `StepMappingEditor_conversionSelect__+JbJ6`,
	"locationBadge": `StepMappingEditor_locationBadge__GThQ2`,
	"path": `StepMappingEditor_path__NstvP`,
	"query": `StepMappingEditor_query__U5COi`,
	"payload": `StepMappingEditor_payload__d47yj`,
	"templateToggleBtn": `StepMappingEditor_templateToggleBtn__WfQzS`,
	"templateToggleBtnActive": `StepMappingEditor_templateToggleBtnActive__YThXU`,
	"removeButton": `StepMappingEditor_removeButton__v3k1s`,
	"autoMapBtn": `StepMappingEditor_autoMapBtn__6waA-`,
	"templateEditor": `StepMappingEditor_templateEditor__eIRlJ`,
	"templateEditorHint": `StepMappingEditor_templateEditorHint__w4BVq`,
	"templateTextarea": `StepMappingEditor_templateTextarea__1rErA`,
	"templateFieldChips": `StepMappingEditor_templateFieldChips__jSHy1`,
	"templateFieldChipsLabel": `StepMappingEditor_templateFieldChipsLabel__V0nHl`,
	"templateFieldChip": `StepMappingEditor_templateFieldChip__RxrSV`,
	"templatePreview": `StepMappingEditor_templatePreview__wgFqa`,
	"templatePreviewJson": `StepMappingEditor_templatePreviewJson__Ve68O`,
	"templatePreviewString": `StepMappingEditor_templatePreviewString__2rEBA`,
	"templatePreviewEmpty": `StepMappingEditor_templatePreviewEmpty__V6OGC`,
	"templatePreviewLabel": `StepMappingEditor_templatePreviewLabel__orjz1`,
	"templatePreviewValue": `StepMappingEditor_templatePreviewValue__ob2mU`
};
export default ___CSS_LOADER_EXPORT___;
